import { safeNextPath } from "../lib/validate";
import { api, messageOf } from "./lib/api";
import { $, show } from "./lib/dom";

const next = safeNextPath(new URLSearchParams(location.search).get("next")) ?? "/dashboard";
const form = $<HTMLFormElement>("#login-form");
const emailInput = $<HTMLInputElement>("#email");
const errorEl = $("#login-error");
const submitButton = $<HTMLButtonElement>("#login-form button[type=submit]");

// Already signed in? Skip the form.
api<{ email: string }>("/api/auth/me")
  .then(() => location.replace(next))
  .catch(() => undefined);

form.addEventListener("submit", async (event) => {
  event.preventDefault();
  show(errorEl, false);
  const email = emailInput.value.trim();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    errorEl.textContent = "Enter a valid email address.";
    show(errorEl);
    emailInput.focus();
    return;
  }
  submitButton.disabled = true;
  try {
    const { message } = await api<{ message: string }>("/api/auth/request", { json: { email, next } });
    $("#login-sent-message").textContent = message;
    show($("#login-form-panel"), false);
    show($("#login-sent-panel"));
  } catch (err) {
    errorEl.textContent = messageOf(err);
    show(errorEl);
  } finally {
    submitButton.disabled = false;
  }
});

$("#login-retry").addEventListener("click", () => {
  show($("#login-sent-panel"), false);
  show($("#login-form-panel"));
  emailInput.select();
});
